export default __webpack_public_path__ + "static/GOSPODARSTVO-OGLEDALO-d474e747e3551f313acb247abf675059.png";